import PaymentCard from "./PaymentCard.jsx";
export {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "../utils/paymentUtils";
export default PaymentCard;
